<template>
  <el-dialog
    title="查看复制进度"
    :visible.sync="dialogVisible"
    width="80%"
    class="copy-progress-dialog"
    @open="handleOpen"
  >
    <div class="copy-progress-search">
      <el-form :inline="true" :model="searchForm" size="mini">
        <el-form-item label="操作人">
          <el-input
            v-model="searchForm.createUserName"
            placeholder="请输入"
            clearable
            class="copy-progress-input"
          />
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input
            v-model="searchForm.targetTenantName"
            placeholder="请输入"
            clearable
            class="copy-progress-input"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">清空</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      border
      stripe
      v-loading="tableLoading"
      height="400"
    >
      <el-table-column
        label="序号"
        width="60"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="targetTenantName"
        label="所属公司"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.targetTenantName || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="复制内容" min-width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.content || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        label="复制结果"
        width="80"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <span :class="getStateClass(scope.row.state)">
            {{ getStateText(scope.row.state) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="失败原因" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.errorInfo || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="操作人" width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.createUserName || scope.row.createUser || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="操作时间" width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.createTime | getTimeDate }}
        </template>
      </el-table-column>
      <el-table-column label="完成时间" width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.finishDate | getTimeDate }}
        </template>
      </el-table-column>
      <el-table-column
        label="耗时"
        width="80"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope"> {{ scope.row.finishTime }}秒 </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="copy-progress-pagination"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    />
  </el-dialog>
</template>

<script>
import { getCopyProgressPageList } from "@/api/msCustomerService.js";

export default {
  data() {
    return {
      dialogVisible: false,
      tableLoading: false,
      tableData: [],
      searchForm: {
        createUserName: "",
        targetTenantName: "",
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalRows: 0,
      },
    };
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 处理打开弹窗
    handleOpen() {
      this.getData();
    },
    // 获取复制进度列表
    async getData() {
      const params = {
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize,
        createUserName: this.searchForm.createUserName,
        targetTenantName: this.searchForm.targetTenantName,
        tenantGuid: localStorage.getItem("guid"),
      };
      this.tableLoading = true;
      const { data } = await getCopyProgressPageList(params);
      this.tableLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      const result = data.data || {};
      this.tableData = result.records || [];
      this.page.totalRows = result.totalRows;
    },
    // 搜索
    handleSearch() {
      this.page.pageIndex = 1;
      this.getData();
    },
    // 重置
    handleReset() {
      this.searchForm = {
        createUserName: "",
        targetTenantName: "",
      };
      this.page.pageIndex = 1;
      this.getData();
    },
    // 处理分页大小改变
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageIndex = 1;
      this.getData();
    },
    // 处理分页当前页改变
    handleCurrentChange(val) {
      this.page.pageIndex = val || 1;
      this.getData();
    },
    // 获取复制进度状态文本
    getStateText(state) {
      const stateTextMap = {
        1: "复制中",
        2: "成功",
        3: "失败",
      };
      return stateTextMap[state] || state || "-";
    },
    // 获取复制进度状态类名
    getStateClass(state) {
      if (state == 2) {
        return "copy-state-success";
      }
      if (state == 3) {
        return "copy-state-fail";
      }
      return "";
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding-top: 18px;
}
.copy-progress-search {
  text-align: left;
}
.copy-progress-search /deep/ .el-form {
  text-align: left;
}
.copy-progress-search /deep/ .el-form-item {
  margin-right: 24px;
  text-align: left;
}
.copy-progress-input {
  width: 260px;
}
.copy-state-success {
  color: #4fa1a4;
  font-weight: 600;
}
.copy-state-fail {
  color: #e76479;
  font-weight: 600;
}
.copy-progress-pagination {
  margin-top: 24px;
  text-align: center;
}
</style>
